import TableCellLink, { TableCellLinkProps } from "ds/components/Table/Row/CellLink";
import { selectColumnSize } from "ds/components/Table/store/useTableStore/selectors";

import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../types";
import useIacTableStore from "../../components/Table/useIacTableStore";

type IacManagementTableLinkProps = {
  columnId: IAC_MANAGEMENTS_TABLE_COLUMNS;
} & TableCellLinkProps;

const IacManagementTableLink = ({ columnId, ...linkProps }: IacManagementTableLinkProps) => {
  // force re-render when column size changes to update the text ellipsis
  useIacTableStore((state) => selectColumnSize(state, columnId));

  return <TableCellLink {...linkProps} />;
};

export default IacManagementTableLink;
